import { render, staticRenderFns } from "./License.List.vue?vue&type=template&id=f31be498&"
import script from "./License.List.vue?vue&type=script&lang=js&"
export * from "./License.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports